import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=fb08d538&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=fb08d538&prod&lang=stylus&scoped=true"
import style1 from "./detail.vue?vue&type=style&index=1&id=fb08d538&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb08d538",
  null
  
)

export default component.exports